import { resolveSeoKey } from "./resolveSeoKey";
import { seoData } from "./seoData";

export interface SeoMeta {
  title: string;
  description: string;
  robots: string;
  // The client's name for og:site_name; empty when it is not known.
  siteName: string;
}

const readName = (value: unknown): string => {
  const name = typeof value === "string" ? value.trim() : "";
  return name === "undefined" || name === "null" ? "" : name;
};

/**
 * The client's display name, as the footer and login side panel show it.
 * Empty while company details are loading or when the client has none — the
 * portal is white-label, so there is no DCDial fallback.
 */
export const getCompanyName = (companyDetails: any): string =>
  readName(companyDetails?.name) || readName(companyDetails?.company_name);

export const buildPageTitle = (pageTitle: string, companyName: string) =>
  companyName ? `${pageTitle} | ${companyName}` : pageTitle;

/**
 * Title, description and robots directive for a path. Only generic page text
 * goes in here: the tab title shows on shared screens and in screenshots, so
 * it must never carry customer names, amounts or account numbers.
 */
export const buildSeoMeta = (
  pathname: string,
  companyDetails: any
): SeoMeta => {
  const entry = seoData[resolveSeoKey(pathname)];
  const companyName = getCompanyName(companyDetails);
  return {
    title: buildPageTitle(entry.title, companyName),
    description: entry.description,
    robots: entry.index ? "index, follow" : "noindex, nofollow",
    siteName: companyName,
  };
};
